import * as React from 'react'
import { any, async, fromJSX, Fun, Updater, Widget } from 'widgets-for-react'
import { isLoggedIn } from '../../../authentication/auth_widget/utils'
import { inject } from '../../../utils/safe-type-casting'
import { RootState, rootStateUpdaters } from '../rootState'
import { FooterLayout } from './footerLayout'
import { FooterState, footerStateUpdaters } from './footerState'

export function footer(state: RootState): Widget<Updater<RootState>> {
  return inject((setOuterState) =>
    any<Fun<FooterState, FooterState>>([
      async(state.footer.menuItems).map((x) => (s1) => ({
        ...s1,
        menuItems: x(s1.menuItems),
      })),
      async(state.footer.subscribeRequest).map((f) => (s1) => ({
        ...s1,
        subscribeRequest: f(s1.subscribeRequest),
      })),
      fromJSX((setState) => (
        <FooterLayout
          menuItems={state.footer.menuItems}
          subscribeRequest={state.footer.subscribeRequest}
          setState={setState}
          isLoggedIn={isLoggedIn(state.authState)}
          languageSwitchMode={state.footer.languageSwitchMode}
          setLanguageSwitchMode={(newMode: 'open' | 'closed') =>
            setState(footerStateUpdaters.updateLanguageMode(newMode))
          }
          onLanguageChanged={() =>
            setOuterState(rootStateUpdaters.languageChanged)
          }
        />
      )),
    ]).map(rootStateUpdaters.updateFooterState)
  )
}
